(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.LUVEEShippingProgress = api;
})(typeof window !== 'undefined' ? window : null, function () {
  const THRESHOLD_CENTS = 49900;
  const DEFAULT_COPY = {
    remaining: 'Add [amount] more and delivery drops to ₹49.',
    unlocked: '₹49 shipping applies to this order.'
  };

  function formatINR(cents) {
    const value = cents / 100;
    return '₹' + value.toLocaleString('en-IN', {
      minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  // Luvee Diwali Dhamaka (31 Oct 00:00 IST - 11 Nov 00:00 IST, 2026): an automatic discount makes standard
  // delivery free from Rs 999, so the bar counts toward Rs 999 instead. Outside the window nothing changes.
  const SALE_START_MS = Date.UTC(2026, 9, 30, 18, 30, 0);
  const SALE_END_MS = Date.UTC(2026, 10, 10, 18, 30, 0);
  const SALE_THRESHOLD_CENTS = 99900;
  const SALE_COPY = {
    remaining: 'Add [amount] more for free delivery (Diwali Dhamaka).',
    unlocked: 'Free delivery on this order.'
  };
  function saleLive(nowMs) {
    const n = typeof nowMs === 'number' ? nowMs : Date.now();
    return n >= SALE_START_MS && n < SALE_END_MS;
  }

  function forTotal(totalCents, copy, nowMs) {
    const parsed = Number(totalCents);
    const normalized = Number.isFinite(parsed) ? Math.max(0, Math.trunc(parsed)) : 0;
    const sale = saleLive(nowMs);
    const THRESHOLD = sale ? SALE_THRESHOLD_CENTS : THRESHOLD_CENTS;
    const currentCents = Math.min(normalized, THRESHOLD);
    const remainingCents = Math.max(0, THRESHOLD - normalized);
    const isUnlocked = normalized >= THRESHOLD;
    const percent = Math.floor((currentCents / THRESHOLD) * 10000) / 100;
    const labels = sale ? Object.assign({}, SALE_COPY) : Object.assign({}, DEFAULT_COPY, copy || {});
    const message = isUnlocked
      ? labels.unlocked
      : labels.remaining.replace('[amount]', formatINR(remainingCents));

    return {
      thresholdCents: THRESHOLD,
      currentCents,
      remainingCents,
      percent,
      isUnlocked,
      message
    };
  }

  return { forTotal, formatINR, saleLive };
});
